import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import { fetchAPI } from "../utility/NetworkUtils";
import DataGridTableToolbar from "@/utility/DataGridTableToolbar";
import DataGrid from "@/layouts/tables/DataGrid";
import { 
  Link,
  Button,
  Chip
} from "@mui/material";
import { isJaguar } from "@/utility/UserUtils";
import UserModal from "./UserModal";
import { useConfirm } from "material-ui-confirm";

const InternalUsersDashboard = (props) => {
  const { 
    user
  } = props
  const confirm = useConfirm()
  const [ loading, setLoading ] = useState(true);
  const [ users, setUsers ] = useState([]);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);

  useEffect(() => {
    fetchUsers()
  }, []);

  const fetchUsers = () => {
    fetchAPI(`/webapi/users`, (json)=> {
      if (!json.errors) {
        setUsers(json.users)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }


  const deleteUser = async (id) => {
    const { confirmed, reason } = await confirm({
      description: "Are you sure you want to delete this user? This cannot be undone.",
      confirmationText: "Yes, Delete This.",
      cancellationText: "No"
    })
    if(confirmed) {
      fetchAPI(`/inventory/:inventory_id/users/${id}`, (json)=> {
        if (!json.errors) {
          fetchUsers()
        } else {
          console.log({
            errors: json.errors
          })
        }
      }, {
        method: "DELETE",
      });
    }
  }



  const renderActions = (params) => {
    let actions = [];
    if(params.row.role == "client") {
      actions.push(
        <Link component="button" onClick={()=>{
          setEditUser(params.row)
          setEditUserModalOpen(true)
        }}>EDIT</Link>
      )

    }
    if(isJaguar(user)) {
      actions.push(<Link href={`/users/${params.row.id}/become_user`}>
        Become User
      </Link>
      )

    }
    if(params.row.role == "client") {
      actions.push(<Link component="button" onClick={()=>{
        deleteUser(params.row.id)
      }}>DELETE</Link>)
    }


    return actions
  }

  const renderInventoryAccessCell = (params) => {
    const renters = (params?.row?.renters||[]).map(renter => {

      return (
        <Chip 
          size="small"
          label={renter.name}
          color="clientblue"
          className="mr-1"
        />
      )
    })
    return (
      <>
        {renters}
      </>
    )
  }

  return (
    <>
      <UserModal
        open={editUserModalOpen}
        onClose={()=>{
          setEditUserModalOpen(false)
          setEditUser(null)
        }}
        onSave={()=>{
          setEditUserModalOpen(false)
          setEditUser(null)
          fetchUsers()
        }}
        user={user}
        editingUser={editUser}
      />
      <h1 class="catalog-h1">User Management</h1>
      <Button
        color="green"
        variant="contained"
        className="mb-4"
        onClick={()=>{
          setEditUser(null)
          setEditUserModalOpen(true)
        }}
      >
        Add New User
      </Button>
      <DataGrid
        rows={users}
        tableName="users"
        columns={[
          {field: "first_name", flex: 1, headerName: "First Name"},
          {field: "last_name", flex: 1, headerName: "Last Name"},
          {field: "email", flex: 1, headerName: "Email"},
          {field: "inventory_access", flex: 1, headerName: "Inventory Access", valueGetter: (params, row) => {
            return (row?.renters||[]).map(x=>x.name).join(", ")
          }, renderCell: renderInventoryAccessCell},
          {
            headerName: "Actions",
            field: "actions",
            type: "actions",
            flex: 1,
            minWidth: 200,
            maxWidth: 250,
            align: "right",
            getActions: renderActions
          }
        ]}
      />
    </>
  );
}

const UsersDashboard = (props) => {
  return (
    <PublicCatalogLayout
      currentPage="users"
      {...props}
      breadcrumbs={[
        {name: "Inventory", url: "/"},
        {name: "User Management", url: "/management/users"}
      ]}
    >
      <InternalUsersDashboard {...props} />
    </PublicCatalogLayout>
  )
}

export default UsersDashboard

